export default "__VITE_PUBLIC_ASSET__983117e2__"